import { createWithEqualityFn as create } from 'zustand/traditional';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createQcastSlice, type QcastSlice } from './qcasts';
import { createAppSlice, type AppSlice } from './app';
import { createAuthSlice, type AuthSlice } from './auth';
import { openDB } from 'idb';
import * as idbKeyval from 'idb-keyval';

const DB_NAME = 'QCastDB';
const STORE_NAME = 'state';
const DB_VERSION = 10

const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'key' });
      }
    },
  });
};

const idbStorage = {
  getItem: async (key: string) => {
    const db = await initDB();
    const entry = await db.get(STORE_NAME, key);
    return entry ? JSON.parse(entry.value) : null;
  },
  setItem: async (key: string, value: any) => {
    const db = await initDB();
    await db.put(STORE_NAME, { key, value: JSON.stringify(value) });
  },
  removeItem: async (key: string) => {
    const db = await initDB();
    await db.delete(STORE_NAME, key);
  },
};

export const storeData = async (keyname: string, data) => {
  try{
    const storedData = {...data};
    
    if (data instanceof Blob) {
      const blobId = `blob_${Date.now()}`;
      await idbKeyval.set(blobId, data);
      storedData.videoBlobId = blobId;
      delete storedData.video;
    }
    
    
    return idbKeyval.set(keyname, storedData);  
  }catch(error: any){
  }
  
};


export const retrieveData = async (keyname: string) => {
  const data = await idbKeyval.get(keyname);
  
  if (data && data.videoBlobId) {
    data.video = await idbKeyval.get(data.videoBlobId);
  }
  
  return data;
};

export const deleteData = async (keyname: string) => {
  await idbKeyval.del(keyname);
  return true;
}

export const clearData = async () => {
  await idbKeyval.clear();
  return true;
}


export type StoreState = QcastSlice & AppSlice & AuthSlice;

export const useBoundStore = create<StoreState>()(
  persist(
    devtools(
      (set, get, api) => ({
        ...createAppSlice(set, get, api),
        ...createAuthSlice(set, get, api),
        ...createQcastSlice(set, get, api),
      }),
      { name: 'QCastStore' }
    ),
    {
      name: 'qcast-store',
      storage: idbStorage,
      onRehydrateStorage: () => (state) => {
        
      }
    }
  )
);

